<template>
  <div class="ChangePassword">
    <div class="list">
      <div class="item">
        <input type="number" placeholder="填写手机号码" v-model="phone" />
      </div>
      <div class="item acea-row row-between-wrapper">
        <input
          type="text"
          placeholder="填写验证码"
          class="codeIput"
          v-model="captcha"
        />
        <button
          class="code font-color-red"
          :disabled="disabled"
          :class="disabled === true ? 'on' : ''"
          @click="code"
        >
          {{ text }}
        </button>
      </div>
    </div>
    <div class="confirmBnt bg-color-red" @click="confirm">确认绑定</div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import store from "@/store";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { registerVerify, wechatBindingPhone } from "@api/user";

export default {
  name: "wxBindPhone",
  components: {},
  props: {},
  data: function() {
    return {
      captcha: "",
      phone: "", //手机号
      check_confirm: 0
    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function() {},
  methods: {
    async confirm() {
      let that = this;
      const { phone, captcha } = that;
      try {
        await that
          .$validator({
            phone: [
              chs_phone(chs_phone.message("手机号码")),
              alpha_num(alpha_num.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ phone, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      // 防止多次点击请求
      if (that.check_confirm === 1) return;
      that.check_confirm = 1;
      console.log(that.check_confirm);
      wechatBindingPhone({
        phone: this.phone,
        captcha: this.captcha,
        spread: parseInt(cookie.get("spread")),
        wechat_info: cookie.get("wechat_info")
      })
        .then(({ data }) => {
          const code = cookie.get("wx_auth");
          const expires_time = dayjs(data.expires_time);
          //const newTime = Math.round(new Date() / 1000);
          store.commit("LOGOUT");
          store.commit("LOGIN", data.token, expires_time);
          cookie.remove("wx_auth");
          cookie.remove("wx_bind_phone");
          cookie.set("wx_auth", code, expires_time);
          cookie.remove("loginType");
          that.$dialog.success(data.msg).then(() => {
            that.$router.replace({ name: "Index" });
          });
        })
        .catch(res => {
          that.check_confirm = 0;
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      let that = this;
      const { phone } = that;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      registerVerify({ phone: phone, real_send: 1 })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>
